import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th
} from '@chakra-ui/react'
import { ApexOptions } from 'apexcharts'
import dayjs from 'dayjs'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import Chart from 'react-apexcharts'
import { useImmer } from 'use-immer'

import useMrpScheduledPurschase from '@hook/mrp/use-scheduled-purchase'

import generic from '@service/generic'

import ScheduledTr from './Utils/ScheduleTr'

const ScheduledPurschaseModalChart: FC = () => {
  const {
    originalData: list,
    selected,
    setSelected,
    handleDataAux
  } = useMrpScheduledPurschase()
  const [_error, setError] = useState(false)

  const [_loading, setLoading] = useState(false)

  const [_data, updateData] = useImmer({
    storage: [],
    sales: []
  })
  const item = useMemo(() => {
    if (selected) {
      const item = list.find(
        (e: any) =>
          e.estoque.produtoFornecedor.produto.id === selected['produto-id']
      )
      return item
    }

    return null
  }, [list, selected])

  const dailyChart = useMemo<ApexOptions>(() => {
    if (item) {
      const labels: any[] = [
        ...new Set(
          item.compraProgramaDesejada.simulacaoDRP.map((val: any) =>
            dayjs(val.data).format('YYYY-MM-DD')
          )
        )
      ]

      return {
        stroke: {
          curve: 'straight',
          dashArray: [0, 2],
          width: [1, 2]
        },
        title: {
          text: 'MRP Compra Programada'
        },
        chart: {
          id: 'dailyChart'
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [1]
        },
        labels,
        xaxis: {
          labels: {
            show: false
          }
        },
        yaxis: [
          {
            title: {
              text: 'Estoque'
            }
          },
          {
            opposite: true,
            title: {
              text: 'Vendas'
            }
          }
        ]
      }
    }

    return {}
  }, [item])

  const dailySeries = useMemo(() => {
    if (item) {
      const labels = [
        ...new Set(
          item.compraProgramaDesejada.simulacaoDRP.map((val: any) => val.data)
        )
      ]

      const storageSeries: number[] = Array.from(
        { length: labels.length },
        () => 0
      )
      const ordersSeries: number[] = Array.from(
        { length: labels.length },
        () => 0
      )

      for (const drp of item.compraProgramaDesejada.simulacaoDRP) {
        const labelIdx = labels.findIndex(label => label === drp.data)

        storageSeries[labelIdx] = parseFloat(drp.finalDisponivel.toFixed(2))
        ordersSeries[labelIdx] = parseFloat(drp.unidadePedido.toFixed(2))
      }

      return [
        {
          name: 'Pedidos Programados',
          type: 'column',
          data: ordersSeries
        },
        {
          name: 'Estoque',
          type: 'column',
          data: storageSeries
        }
      ]
    }

    return []
  }, [item])

  const handleModalClose = () => {
    setSelected(null)
  }

  const getChartData = useCallback(async () => {
    setLoading(true)
    setError(false)

    try {
      const {
        data: { data: storage }
      } = await generic.getStorageChart(
        selected['centro-id'],
        selected['produto-id']
      )

      const {
        data: { data: sales }
      } = await generic.getSalesChart(
        selected['centro-id'],
        selected['produto-id']
      )

      updateData(draft => {
        draft.storage = storage
        draft.sales = sales
      })
    } catch {
      setError(true)
    }

    setLoading(false)
  }, [selected, updateData])

  useEffect(() => {
    if (selected) {
      getChartData()
    }
  }, [selected, getChartData])
  return (
    <Modal
      isOpen={!!selected}
      onClose={handleModalClose}
      motionPreset="slideInBottom"
      size="4xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bgColor="white">Gráfico</ModalHeader>
        <ModalCloseButton onClick={handleDataAux} />
        <ModalBody bgColor="white" pb={6}>
          <Chart
            options={dailyChart}
            series={dailySeries}
            width="100%"
            height="240px"
          />
          <Table variant="simple" mt={6}>
            <Thead>
              <Tr>
                <Th width={5}>Nº Pedido</Th>
                <Th isNumeric>Data</Th>
                <Th>Quantidade</Th>
                <Th isNumeric>Custo (R$)</Th>
              </Tr>
            </Thead>
            <Tbody>
              {item?.compraProgramaDesejada.simulacaoDRP
                .filter((row: any) => row.diaDePedido)
                .map((row: any, idx: number) => (
                  <ScheduledTr
                    key={`tr-${idx + 1}`}
                    id={idx + 1}
                    date={dayjs(row.data).format('DD/MM/YYYY')}
                    dateDefault={row.data}
                    defaultQuantity={row.unidadePedido}
                    entity={item}
                  />
                ))}
            </Tbody>
          </Table>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ScheduledPurschaseModalChart
